// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url('https://fonts.googleapis.com/css2?family=Vazirmatn:wght@300;400;500;600;700&display=swap'); */

.ComingSoon_container__TW7MS {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  padding: 20px;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%);
  position: relative;
  overflow: hidden;
}

.ComingSoon_container__TW7MS::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 20% 80%, rgba(6, 182, 212, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(14, 165, 233, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 40% 40%, rgba(59, 130, 246, 0.08) 0%, transparent 50%);
  animation: ComingSoon_backgroundFloat__5zD0\\+ 12s ease-in-out infinite alternate;
}

@keyframes ComingSoon_backgroundFloat__5zD0\\+ {
  0% { transform: translateX(-8px) translateY(-8px); }
  100% { transform: translateX(8px) translateY(8px); }
}

.ComingSoon_card__hY60S {
  position: relative;
  background: rgba(255, 255, 255, 0.02);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(148, 163, 184, 0.1);
  border-radius: 16px;
  padding: 48px 64px;
  text-align: center;
  box-shadow: 
    0 20px 25px -5px rgba(0, 0, 0, 0.3),
    0 10px 10px -5px rgba(0, 0, 0, 0.2),
    inset 0 1px 0 rgba(148, 163, 184, 0.1);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  z-index: 2;
}

.ComingSoon_card__hY60S:hover {
  transform: translateY(-4px);
  box-shadow: 
    0 32px 64px -12px rgba(0, 0, 0, 0.4),
    0 20px 32px -8px rgba(6, 182, 212, 0.1),
    inset 0 1px 0 rgba(148, 163, 184, 0.15);
  border-color: rgba(6, 182, 212, 0.2);
}

.ComingSoon_glowEffect__gcz2j {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: conic-gradient(
    from 0deg,
    transparent 0deg,
    rgba(6, 182, 212, 0.2) 60deg,
    rgba(14, 165, 233, 0.2) 120deg,
    rgba(59, 130, 246, 0.2) 180deg,
    rgba(6, 182, 212, 0.2) 240deg,
    transparent 360deg
  );
  animation: ComingSoon_rotate__HVkxB 15s linear infinite;
  opacity: 0.5;
  z-index: -1;
}

@keyframes ComingSoon_rotate__HVkxB {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.ComingSoon_persianText__Zio1Z {
  font-family: 'Vazirmatn', 'Tahoma', sans-serif;
  font-size: 3.2rem;
  font-weight: 700;
  background: linear-gradient(
    135deg, 
    #06b6d4 0%, 
    #0ea5e9 30%, 
    #3b82f6 60%, 
    #06b6d4 100%
  );
  background-size: 300% 300%;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: ComingSoon_gradientShift__WNQ4f 6s ease-in-out infinite;
  margin-bottom: 12px;
  letter-spacing: 1px;
  text-shadow: 0 0 20px rgba(6, 182, 212, 0.2);
  position: relative;
}

@keyframes ComingSoon_gradientShift__WNQ4f {
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
}

.ComingSoon_persianText__Zio1Z::after {
  content: '';
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 2px;
  background: linear-gradient(90deg, transparent, #06b6d4, transparent);
  border-radius: 1px;
  animation: ComingSoon_underlineGlow__xogL- 3s ease-in-out infinite alternate;
}

@keyframes ComingSoon_underlineGlow__xogL- {
  0% { 
    opacity: 0.6; 
    width: 50px; 
    box-shadow: 0 0 10px rgba(6, 182, 212, 0.3);
  }
  100% { 
    opacity: 1; 
    width: 80px; 
    box-shadow: 0 0 20px rgba(6, 182, 212, 0.6);
  }
}

.ComingSoon_subtitle__3ydtB {
  font-family: 'Inter', 'system-ui', sans-serif;
  font-size: 0.9rem;
  font-weight: 500;
  color: #94a3b8;
  margin-top: 16px;
  letter-spacing: 2px;
  text-transform: uppercase;
  opacity: 0.9;
}

.ComingSoon_decorativeDots__OGiZz {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 32px;
}

.ComingSoon_decorativeDots__OGiZz span {
  width: 6px;
  height: 6px;
  background: linear-gradient(45deg, #06b6d4, #0ea5e9);
  border-radius: 50%;
  display: inline-block;
  animation: ComingSoon_dotPulse__IeAe2 2s ease-in-out infinite;
  box-shadow: 0 0 8px rgba(6, 182, 212, 0.4);
}

.ComingSoon_decorativeDots__OGiZz span:nth-child(1) {
  animation-delay: 0s;
}

.ComingSoon_decorativeDots__OGiZz span:nth-child(2) {
  animation-delay: 0.3s;
}

.ComingSoon_decorativeDots__OGiZz span:nth-child(3) {
  animation-delay: 0.6s;
}

@keyframes ComingSoon_dotPulse__IeAe2 {
  0%, 100% { 
    transform: scale(0.8); 
    opacity: 0.5; 
  }
  50% { 
    transform: scale(1.3); 
    opacity: 1; 
  }
}

/* Premium hover effects matching site style */
.ComingSoon_card__hY60S::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(6, 182, 212, 0.08),
    transparent
  );
  transition: left 0.6s ease-out;
}

.ComingSoon_card__hY60S:hover::before {
  left: 100%;
}

.ComingSoon_card__hY60S::after {
  content: '✦';
  position: absolute;
  top: 16px;
  right: 20px;
  color: rgba(6, 182, 212, 0.4);
  font-size: 1rem;
  animation: ComingSoon_sparkle__X21o0 4s ease-in-out infinite;
}

@keyframes ComingSoon_sparkle__X21o0 {
  0%, 100% { 
    opacity: 0.2; 
    transform: scale(0.8) rotate(0deg); 
  }
  50% { 
    opacity: 0.8; 
    transform: scale(1.1) rotate(180deg); 
  }
}

/* Compact version */
.ComingSoon_container__TW7MS.ComingSoon_compact__8PDrA {
  min-height: 220px;
  padding: 16px;
}

.ComingSoon_container__TW7MS.ComingSoon_compact__8PDrA .ComingSoon_card__hY60S {
  padding: 32px 48px;
}

.ComingSoon_container__TW7MS.ComingSoon_compact__8PDrA .ComingSoon_persianText__Zio1Z {
  font-size: 2.6rem;
  margin-bottom: 8px;
}

.ComingSoon_container__TW7MS.ComingSoon_compact__8PDrA .ComingSoon_subtitle__3ydtB {
  font-size: 0.8rem;
  margin-top: 12px;
  letter-spacing: 1.5px;
}

.ComingSoon_container__TW7MS.ComingSoon_compact__8PDrA .ComingSoon_decorativeDots__OGiZz {
  margin-top: 24px;
}

/* Responsive Design matching site breakpoints */
@media (max-width: 1024px) {
  .ComingSoon_card__hY60S {
    padding: 40px 52px;
  }
  
  .ComingSoon_persianText__Zio1Z {
    font-size: 2.8rem;
  }
}

@media (max-width: 768px) {
  .ComingSoon_container__TW7MS {
    padding: 16px;
    min-height: 260px;
  }
  
  .ComingSoon_card__hY60S {
    padding: 36px 44px;
    margin: 0 8px;
    border-radius: 14px;
  }
  
  .ComingSoon_persianText__Zio1Z {
    font-size: 2.4rem;
    letter-spacing: 0.5px;
  }
  
  .ComingSoon_subtitle__3ydtB {
    font-size: 0.85rem;
    letter-spacing: 1.5px;
  }
}

@media (max-width: 480px) {
  .ComingSoon_container__TW7MS {
    padding: 12px;
    min-height: 240px;
  }
  
  .ComingSoon_card__hY60S {
    padding: 28px 32px;
    margin: 0 4px;
    border-radius: 12px;
  }
  
  .ComingSoon_persianText__Zio1Z {
    font-size: 2rem;
    letter-spacing: 0px;
  }
  
  .ComingSoon_subtitle__3ydtB {
    font-size: 0.75rem;
    letter-spacing: 1px;
  }
  
  .ComingSoon_decorativeDots__OGiZz {
    margin-top: 24px;
    gap: 8px;
  }
  
  .ComingSoon_decorativeDots__OGiZz span {
    width: 5px;
    height: 5px;
  }
}

/* Integration with your site's existing styles */
.ComingSoon_card__hY60S {
  /* Matches your site's card shadows and borders */
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
}

.ComingSoon_card__hY60S:hover {
  /* Enhanced shadow on hover matching site interaction */
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
}

/* Dark theme already built-in to match your site */
@media (prefers-color-scheme: light) {
  .ComingSoon_container__TW7MS {
    background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 50%, #cbd5e1 100%);
  }
  
  .ComingSoon_card__hY60S {
    background: rgba(255, 255, 255, 0.7);
    border: 1px solid rgba(148, 163, 184, 0.2);
  }
  
  .ComingSoon_subtitle__3ydtB {
    color: #64748b;
  }
  
  .ComingSoon_persianText__Zio1Z {
    background: linear-gradient(135deg, #0891b2 0%, #0284c7 30%, #2563eb 60%, #0891b2 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}

/* Additional utility classes for site integration */
.ComingSoon_container__TW7MS.ComingSoon_fullWidth__lTO8M {
  width: 100%;
  border-radius: 0;
}

.ComingSoon_container__TW7MS.ComingSoon_sectionSpacing__69IkY {
  margin: 4rem 0;
}

.ComingSoon_container__TW7MS.ComingSoon_centerInPage__8eoV9 {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 50;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Errors/ComingSoon.module.css"],"names":[],"mappings":"AAAA,6GAA6G;;AAE7G;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,0EAA0E;EAC1E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;oFAGkF;EAClF,gFAA6D;AAC/D;;AAEA;EACE,KAAK,4CAA4C,EAAE;EACnD,OAAO,0CAA0C,EAAE;AACrD;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB;;;0CAGwC;EACxC,iDAAiD;EACjD,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B;;;2CAGyC;EACzC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ;;;;;;;;GAQC;EACD,uDAAqC;EACrC,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,8CAA8C;EAC9C,iBAAiB;EACjB,gBAAgB;EAChB;;;;;;GAMC;EACD,0BAA0B;EAC1B,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;EACpC,kEAAgD;EAChD,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,WAAW,2BAA2B,EAAE;EACxC,MAAM,6BAA6B,EAAE;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,qEAAqE;EACrE,kBAAkB;EAClB,4EAA0D;AAC5D;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;IACX,2CAA2C;EAC7C;EACA;IACE,UAAU;IACV,WAAW;IACX,2CAA2C;EAC7C;AACF;;AAEA;EACE,6CAA6C;EAC7C,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oDAAoD;EACpD,kBAAkB;EAClB,qBAAqB;EACrB,6DAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,6BAA6B;EAC7B,eAAe;EACf,4DAA0C;AAC5C;;AAEA;EACE;IACE,YAAY;IACZ,kCAAkC;EACpC;EACA;IACE,YAAY;IACZ,oCAAoC;EACtC;AACF;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,UAAU;IACV,WAAW;EACb;AACF;;AAEA,iDAAiD;AACjD;EACE,iDAAiD;EACjD,gFAAgF;EAChF,oGAAoG;AACtG;;AAEA;EACE,uDAAuD;EACvD,gDAAgD;EAChD,6DAA6D;AAC/D;;AAEA,mDAAmD;AACnD;EACE;IACE,0EAA0E;EAC5E;;EAEA;IACE,oCAAoC;IACpC,0CAA0C;EAC5C;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,uFAAuF;IACvF,qBAAqB;IACrB,6BAA6B;IAC7B,oCAAoC;EACtC;AACF;;AAEA,oDAAoD;AACpD;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;AACb","sourcesContent":["/* @import url('https://fonts.googleapis.com/css2?family=Vazirmatn:wght@300;400;500;600;700&display=swap'); */\r\n\r\n.container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 300px;\r\n  padding: 20px;\r\n  background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%);\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.container::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: \r\n    radial-gradient(circle at 20% 80%, rgba(6, 182, 212, 0.1) 0%, transparent 50%),\r\n    radial-gradient(circle at 80% 20%, rgba(14, 165, 233, 0.1) 0%, transparent 50%),\r\n    radial-gradient(circle at 40% 40%, rgba(59, 130, 246, 0.08) 0%, transparent 50%);\r\n  animation: backgroundFloat 12s ease-in-out infinite alternate;\r\n}\r\n\r\n@keyframes backgroundFloat {\r\n  0% { transform: translateX(-8px) translateY(-8px); }\r\n  100% { transform: translateX(8px) translateY(8px); }\r\n}\r\n\r\n.card {\r\n  position: relative;\r\n  background: rgba(255, 255, 255, 0.02);\r\n  backdrop-filter: blur(20px);\r\n  border: 1px solid rgba(148, 163, 184, 0.1);\r\n  border-radius: 16px;\r\n  padding: 48px 64px;\r\n  text-align: center;\r\n  box-shadow: \r\n    0 20px 25px -5px rgba(0, 0, 0, 0.3),\r\n    0 10px 10px -5px rgba(0, 0, 0, 0.2),\r\n    inset 0 1px 0 rgba(148, 163, 184, 0.1);\r\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\r\n  overflow: hidden;\r\n  z-index: 2;\r\n}\r\n\r\n.card:hover {\r\n  transform: translateY(-4px);\r\n  box-shadow: \r\n    0 32px 64px -12px rgba(0, 0, 0, 0.4),\r\n    0 20px 32px -8px rgba(6, 182, 212, 0.1),\r\n    inset 0 1px 0 rgba(148, 163, 184, 0.15);\r\n  border-color: rgba(6, 182, 212, 0.2);\r\n}\r\n\r\n.glowEffect {\r\n  position: absolute;\r\n  top: -50%;\r\n  left: -50%;\r\n  width: 200%;\r\n  height: 200%;\r\n  background: conic-gradient(\r\n    from 0deg,\r\n    transparent 0deg,\r\n    rgba(6, 182, 212, 0.2) 60deg,\r\n    rgba(14, 165, 233, 0.2) 120deg,\r\n    rgba(59, 130, 246, 0.2) 180deg,\r\n    rgba(6, 182, 212, 0.2) 240deg,\r\n    transparent 360deg\r\n  );\r\n  animation: rotate 15s linear infinite;\r\n  opacity: 0.5;\r\n  z-index: -1;\r\n}\r\n\r\n@keyframes rotate {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n.persianText {\r\n  font-family: 'Vazirmatn', 'Tahoma', sans-serif;\r\n  font-size: 3.2rem;\r\n  font-weight: 700;\r\n  background: linear-gradient(\r\n    135deg, \r\n    #06b6d4 0%, \r\n    #0ea5e9 30%, \r\n    #3b82f6 60%, \r\n    #06b6d4 100%\r\n  );\r\n  background-size: 300% 300%;\r\n  background-clip: text;\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  animation: gradientShift 6s ease-in-out infinite;\r\n  margin-bottom: 12px;\r\n  letter-spacing: 1px;\r\n  text-shadow: 0 0 20px rgba(6, 182, 212, 0.2);\r\n  position: relative;\r\n}\r\n\r\n@keyframes gradientShift {\r\n  0%, 100% { background-position: 0% 50%; }\r\n  50% { background-position: 100% 50%; }\r\n}\r\n\r\n.persianText::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: -6px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 60px;\r\n  height: 2px;\r\n  background: linear-gradient(90deg, transparent, #06b6d4, transparent);\r\n  border-radius: 1px;\r\n  animation: underlineGlow 3s ease-in-out infinite alternate;\r\n}\r\n\r\n@keyframes underlineGlow {\r\n  0% { \r\n    opacity: 0.6; \r\n    width: 50px; \r\n    box-shadow: 0 0 10px rgba(6, 182, 212, 0.3);\r\n  }\r\n  100% { \r\n    opacity: 1; \r\n    width: 80px; \r\n    box-shadow: 0 0 20px rgba(6, 182, 212, 0.6);\r\n  }\r\n}\r\n\r\n.subtitle {\r\n  font-family: 'Inter', 'system-ui', sans-serif;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  color: #94a3b8;\r\n  margin-top: 16px;\r\n  letter-spacing: 2px;\r\n  text-transform: uppercase;\r\n  opacity: 0.9;\r\n}\r\n\r\n.decorativeDots {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  margin-top: 32px;\r\n}\r\n\r\n.decorativeDots span {\r\n  width: 6px;\r\n  height: 6px;\r\n  background: linear-gradient(45deg, #06b6d4, #0ea5e9);\r\n  border-radius: 50%;\r\n  display: inline-block;\r\n  animation: dotPulse 2s ease-in-out infinite;\r\n  box-shadow: 0 0 8px rgba(6, 182, 212, 0.4);\r\n}\r\n\r\n.decorativeDots span:nth-child(1) {\r\n  animation-delay: 0s;\r\n}\r\n\r\n.decorativeDots span:nth-child(2) {\r\n  animation-delay: 0.3s;\r\n}\r\n\r\n.decorativeDots span:nth-child(3) {\r\n  animation-delay: 0.6s;\r\n}\r\n\r\n@keyframes dotPulse {\r\n  0%, 100% { \r\n    transform: scale(0.8); \r\n    opacity: 0.5; \r\n  }\r\n  50% { \r\n    transform: scale(1.3); \r\n    opacity: 1; \r\n  }\r\n}\r\n\r\n/* Premium hover effects matching site style */\r\n.card::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: -100%;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: linear-gradient(\r\n    90deg,\r\n    transparent,\r\n    rgba(6, 182, 212, 0.08),\r\n    transparent\r\n  );\r\n  transition: left 0.6s ease-out;\r\n}\r\n\r\n.card:hover::before {\r\n  left: 100%;\r\n}\r\n\r\n.card::after {\r\n  content: '✦';\r\n  position: absolute;\r\n  top: 16px;\r\n  right: 20px;\r\n  color: rgba(6, 182, 212, 0.4);\r\n  font-size: 1rem;\r\n  animation: sparkle 4s ease-in-out infinite;\r\n}\r\n\r\n@keyframes sparkle {\r\n  0%, 100% { \r\n    opacity: 0.2; \r\n    transform: scale(0.8) rotate(0deg); \r\n  }\r\n  50% { \r\n    opacity: 0.8; \r\n    transform: scale(1.1) rotate(180deg); \r\n  }\r\n}\r\n\r\n/* Compact version */\r\n.container.compact {\r\n  min-height: 220px;\r\n  padding: 16px;\r\n}\r\n\r\n.container.compact .card {\r\n  padding: 32px 48px;\r\n}\r\n\r\n.container.compact .persianText {\r\n  font-size: 2.6rem;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.container.compact .subtitle {\r\n  font-size: 0.8rem;\r\n  margin-top: 12px;\r\n  letter-spacing: 1.5px;\r\n}\r\n\r\n.container.compact .decorativeDots {\r\n  margin-top: 24px;\r\n}\r\n\r\n/* Responsive Design matching site breakpoints */\r\n@media (max-width: 1024px) {\r\n  .card {\r\n    padding: 40px 52px;\r\n  }\r\n  \r\n  .persianText {\r\n    font-size: 2.8rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .container {\r\n    padding: 16px;\r\n    min-height: 260px;\r\n  }\r\n  \r\n  .card {\r\n    padding: 36px 44px;\r\n    margin: 0 8px;\r\n    border-radius: 14px;\r\n  }\r\n  \r\n  .persianText {\r\n    font-size: 2.4rem;\r\n    letter-spacing: 0.5px;\r\n  }\r\n  \r\n  .subtitle {\r\n    font-size: 0.85rem;\r\n    letter-spacing: 1.5px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .container {\r\n    padding: 12px;\r\n    min-height: 240px;\r\n  }\r\n  \r\n  .card {\r\n    padding: 28px 32px;\r\n    margin: 0 4px;\r\n    border-radius: 12px;\r\n  }\r\n  \r\n  .persianText {\r\n    font-size: 2rem;\r\n    letter-spacing: 0px;\r\n  }\r\n  \r\n  .subtitle {\r\n    font-size: 0.75rem;\r\n    letter-spacing: 1px;\r\n  }\r\n  \r\n  .decorativeDots {\r\n    margin-top: 24px;\r\n    gap: 8px;\r\n  }\r\n  \r\n  .decorativeDots span {\r\n    width: 5px;\r\n    height: 5px;\r\n  }\r\n}\r\n\r\n/* Integration with your site's existing styles */\r\n.card {\r\n  /* Matches your site's card shadows and borders */\r\n  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\r\n  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);\r\n}\r\n\r\n.card:hover {\r\n  /* Enhanced shadow on hover matching site interaction */\r\n  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);\r\n  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);\r\n}\r\n\r\n/* Dark theme already built-in to match your site */\r\n@media (prefers-color-scheme: light) {\r\n  .container {\r\n    background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 50%, #cbd5e1 100%);\r\n  }\r\n  \r\n  .card {\r\n    background: rgba(255, 255, 255, 0.7);\r\n    border: 1px solid rgba(148, 163, 184, 0.2);\r\n  }\r\n  \r\n  .subtitle {\r\n    color: #64748b;\r\n  }\r\n  \r\n  .persianText {\r\n    background: linear-gradient(135deg, #0891b2 0%, #0284c7 30%, #2563eb 60%, #0891b2 100%);\r\n    background-clip: text;\r\n    -webkit-background-clip: text;\r\n    -webkit-text-fill-color: transparent;\r\n  }\r\n}\r\n\r\n/* Additional utility classes for site integration */\r\n.container.fullWidth {\r\n  width: 100%;\r\n  border-radius: 0;\r\n}\r\n\r\n.container.sectionSpacing {\r\n  margin: 4rem 0;\r\n}\r\n\r\n.container.centerInPage {\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  z-index: 50;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ComingSoon_container__TW7MS`,
	"backgroundFloat": `ComingSoon_backgroundFloat__5zD0+`,
	"card": `ComingSoon_card__hY60S`,
	"glowEffect": `ComingSoon_glowEffect__gcz2j`,
	"rotate": `ComingSoon_rotate__HVkxB`,
	"persianText": `ComingSoon_persianText__Zio1Z`,
	"gradientShift": `ComingSoon_gradientShift__WNQ4f`,
	"underlineGlow": `ComingSoon_underlineGlow__xogL-`,
	"subtitle": `ComingSoon_subtitle__3ydtB`,
	"decorativeDots": `ComingSoon_decorativeDots__OGiZz`,
	"dotPulse": `ComingSoon_dotPulse__IeAe2`,
	"sparkle": `ComingSoon_sparkle__X21o0`,
	"compact": `ComingSoon_compact__8PDrA`,
	"fullWidth": `ComingSoon_fullWidth__lTO8M`,
	"sectionSpacing": `ComingSoon_sectionSpacing__69IkY`,
	"centerInPage": `ComingSoon_centerInPage__8eoV9`
};
export default ___CSS_LOADER_EXPORT___;
